/** @module SiteAdmin/LingerNotificationInDaysRenderer */
define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/heading/Number",
	"csi/locale",
	"csi/widget/InlineSelect"
], function (declare, Memory, NumberRen, locale, InlineSelect) {

	/**
	 * Add units to given number
	 * @param {number} i
	 * @return {string}
	 */
	function days(i) {
		return locale.resource(i > 1 ? "TIME_calDays" : "TIME_calDay", [i]);
	}

	/**
	 * Create a store with 7, 15, 30 and 60 days
	 */
	function _getStore() {
		let data = [7, 15, 30, 60].map((i) => ({ id: i, name: days(i) }));

		return new Memory({ data });
	}

	return declare(NumberRen, {
		/**
		 * @override
		 * Add day(s) to value
		 */
		formatValue: function (value, format) {
			return days(value);
		},

		/**
		 * @override
		 * Create store for days values and select control to edit
		 */
		toHtmlDynamic: function (ctx, h, refNode, params) {
			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}

			params.pageSize = Infinity;
			params.store = params.store || _getStore();
			params.value = (params.value == null) ? "" : String(params.value);

			return new InlineSelect(params);
		},

		/**
		 * @override
		 * Return attribute value from edit control
		 */
		fromHtmlDynamic: function (ctx, h, editNode) {
			return Number(this.getEditorValue(ctx, editNode));
		},

		/**
		 * @override
		 * Need to set id explicitly to use base action and controller
		 */
		_getAction: function () {
			var a = this.inherited(arguments);
			a.classController = "csi.heading.SelectController";
			return a;
		},

		/**
		 * @override
		 *  Use the InlineSelect widget as the editor
		 */
		useReactInlineDialog() {
			return false;
		},
	});
});